import React from 'react';
import Typography from 'carbon-react/lib/components/typography';
import Box from 'carbon-react/lib/components/box';
import Button from 'carbon-react/lib/components/button/';

import { FormattedMessage } from '@futrli/localisation';

import { ListingPageHelpLink } from '@futrli/ui-components/components/listing-page/listing-page-help-link/listing-page-help-link';

interface Props {
  onCreateClick: () => void;
}

export const PageHeader = ({ onCreateClick }: Props) => (
  <Box display="flex" justifyContent="space-between" alignItems="center" mb="24px">
    <Box display="flex" alignItems="center">
      <Typography variant="h1" fontSize="24px" fontWeight="700" mb={0} mr="24px">
        <FormattedMessage id="predict.non_financial_drivers" defaultMessage="Non-financial drivers" />
      </Typography>
      <ListingPageHelpLink url="https://support.futrli.com/en/articles/14597403-non-financial-drivers" />
    </Box>
    <Button buttonType="primary" onClick={onCreateClick}>
      <FormattedMessage id="predict.create_non_financial_driver" defaultMessage="Create non-financial driver" />
    </Button>
  </Box>
);
